import React, { FC, useEffect, useState } from 'react';
import { graphql, useStaticQuery } from 'gatsby';

import CustomResultsHandler from 'common/Filters/CustomResultsHandler';

import { ModulesContent } from '../../@types/content/modules';
import CaseStudySliderCustomHits from './CaseStudySliderCustomHits';
import { CaseStudySliderProps } from './models';
import SlidesWrapper from './SlidesWrapper';
import { getNestedItems } from './utils';

const CaseStudySlider: FC<CaseStudySliderProps> = ({ module }) => {
  const {
    commonFields: { pulledArticlesNoResultsText },
  } = useStaticQuery(graphql`
    {
      commonFields {
        pulledArticlesNoResultsText
      }
    }
  `);

  const { slides, title, backgroundColor } = module;
  const [pulledSlides, setPulledSlides] = useState<ModulesContent.CaseStudySliderPulledItemsType>();

  useEffect(() => {
    if (slides[0].__typename === 'CaseStudySliderPulledItems') {
      const pulledItems = module.slides[0] as ModulesContent.CaseStudySliderPulledItemsType;
      setPulledSlides(pulledItems);
    }
  }, []);

  if (slides[0].__typename === 'CaseStudySliderNestedItems') {
    return (
      <SlidesWrapper
        title={title}
        backgroundColor={module.backgroundColor}
        items={getNestedItems(module.slides[0] as ModulesContent.CaseStudySliderNestedItemsType)}
      />
    );
  }

  return (
    <CustomResultsHandler noResultsText={pulledArticlesNoResultsText}>
      <CaseStudySliderCustomHits
        title={title}
        backgroundColor={backgroundColor}
        playVideoButtonText={pulledSlides?.playVideoButtonText}
        linkText={pulledSlides?.linkText}
      />
    </CustomResultsHandler>
  );
};

export default CaseStudySlider;
